import { request } from '@umijs/max';

export interface PendingContentResponse {
  has_pending: boolean;
  count: number;
  message: string;
}

/**
 * 检查用户是否有待处理的异常内容
 */
export async function checkPendingContent(): Promise<PendingContentResponse> {
  return request('/api/abnormal-content/check-pending', {
    method: 'GET',
  });
}
